// extracted by mini-css-extract-plugin
export default {"grid":"PUk0i","wrapperSidebar":"oIhup","mainContent":"vgEpj","sidebarPositioner":"jGYjm"};